import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { environment } from "src/config/environment";

const DynamicLogo = ({ redirectToHome }) => {
	const { selectedTheme } = useSelector((state: RootState) => state.themeManagementSlice);
	const [Logo, setLogo] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		const ImportIcon = async () => {
			try {
				// const logoPath = await import(`public/icon/${environment.REACT_APP_INSTANCE_NAME}.svg`);
				const logoPath = await import(`public/icon/LeftLogo${environment.REACT_APP_INSTANCE_NAME}.svg?url`);
				setLogo(logoPath.default);
			} catch (err) {
				console.error("Error loading logo:", err);
				setError("Logo not found");
			}
		};
		ImportIcon();
	}, []);

	if (error) return <div>{error}</div>;
	if (!Logo) return null;

	const sidebarColor = getComputedStyle(document.documentElement).getPropertyValue("--sidebar-color").trim();
	const isSidebarColorWhite = sidebarColor === "#ffffff" || sidebarColor === "white" || sidebarColor === "#fff";
	const isSideNavbarPrimary = selectedTheme?.isSideNavbarPrimary;

	// return <Logo className="min-w-32 w-fit item-center text-start cursor-pointer" onClick={redirectToHome} />;
	return <img src={Logo} className={`min-w-32 w-fit item-center text-start cursor-pointer ${isSideNavbarPrimary && "-ml-6 !pl-0"}`} onClick={redirectToHome} alt="Logo" />;
};

export default memo(DynamicLogo);
